import React, { useState } from "react";
import { topCoinDistributionCardService } from "../services/topCoinDistributionCardService";
import { toast } from "react-toastify";

function TopCoinDistributionCardEditForm({ assignment, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    status: assignment.status || "active",
    notes: assignment.notes || "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await topCoinDistributionCardService.updateAssignment(assignment.id, formData);
      if (response.status) {
        toast.success("Assignment updated successfully.");
        onSuccess();
      } else {
        toast.error(response.message || "Failed to update assignment.");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to update assignment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
          <h3 style={{ margin: 0, color: "#1e3a8a", fontSize: "18px" }}>Edit Assignment #{assignment.id}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "18px", cursor: "pointer", color: "#64748b" }}>✕</button>
        </div>

        <div style={{ backgroundColor: "#f8fafc", padding: "12px", borderRadius: "6px", marginBottom: "15px", fontSize: "13px" }}>
          <p style={{ margin: "2px 0" }}><strong>Shop:</strong> {assignment.retail_business?.first_name} {assignment.retail_business?.last_name}</p>
          <p style={{ margin: "2px 0" }}><strong>Tier:</strong> {assignment.card_tier} ({assignment.top_coin_value} TC)</p>
          <p style={{ margin: "2px 0" }}><strong>Cards:</strong> {assignment.start_card_no} - {assignment.end_card_no} ({assignment.total_assigned_quantity ?? assignment.quantity} cards)</p>
        </div>

        <form onSubmit={handleSubmit} style={formStyle}>
          <div className="form-group" style={groupStyle}>
            <label style={labelStyle}>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="form-group" style={groupStyle}>
            <label style={labelStyle}>Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              style={{ ...inputStyle, minHeight: "80px" }}
              maxLength={65535}
            />
          </div>

          <div className="modal-actions" style={actionsStyle}>
            <button type="button" onClick={onClose} style={cancelBtnStyle} disabled={loading}>
              Cancel
            </button>
            <button type="submit" style={submitBtnStyle} disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1050,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "26px",
  borderRadius: "10px",
  width: "440px",
  maxWidth: "92%",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.2)",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "15px" };
const groupStyle = { display: "flex", flexDirection: "column", gap: "4px" };
const labelStyle = { fontSize: "13px", fontWeight: "600", color: "#374151" };
const inputStyle = { padding: "9px 12px", border: "1px solid #cbd5e1", borderRadius: "6px", fontSize: "13px" };
const actionsStyle = { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" };
const btnBase = { padding: "10px 18px", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "600", fontSize: "13px" };
const cancelBtnStyle = { ...btnBase, backgroundColor: "#f1f5f9", color: "#475569" };
const submitBtnStyle = { ...btnBase, backgroundColor: "#1e3a8a", color: "#fff" };

export default TopCoinDistributionCardEditForm;
